export default __webpack_public_path__ + "static/media/5.Tsahim hereglee.dd9468ad.png";